import { Injectable } from '@angular/core';
import { BaseMapper } from '@shared/data';
import { v4 } from 'uuid';
import { TimeSlotDto } from '../dto';
import { TimeSlotBookingModel } from '../model';

@Injectable({
    providedIn: 'root',
})
export class TimeSlotBookingMapper extends BaseMapper<TimeSlotBookingModel, TimeSlotDto> {
    public mapDtoToModel(dto: TimeSlotDto): TimeSlotBookingModel {
        return {
            guid: v4(),
            start: this.stringDateToDayjs(dto.start),
            end: this.stringDateToDayjs(dto.end),
            scheduleId: dto.scheduleId,
            subcontractorId: dto.subcontractorId,
            maskedSubcontractorId: dto.maskedSubcontractorId,
            subcontractorName: dto.subcontractorName,
            maskedAssetId: dto.maskedAssetId,
        };
    }
}
